import { HttpRequestPut } from "../../service";

export type MarkDeliveryAsStatusCase = "Delivered" | "Cancelled" | "Failed";

type MarkDeliveryAsRequestModel = {
  DeliveryId: string;
  Status: MarkDeliveryAsStatusCase;
};

export function markDeliveryAs(
  body: MarkDeliveryAsRequestModel,
  callback: (resp: any) => void,
  errCallback: (err: string) => void,
) {
  HttpRequestPut(
    `/portal/delivery/mark-as`,
    () => undefined,
    (response: any) => {
      callback(response.Result);
    },
    (err: string) => errCallback(err),
    true,
    body,
  );
}
